import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { EconFinancialHealth } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FinancialHealthTag } from '@new/domains/properties/FinancialHealthTag'

import { FiltersSharedProps } from './Filters.types'

interface FinancialHealthFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _FinancialHealthFilter: FC<FinancialHealthFilterProps> = props => {
  const accountStatusOptions = Object.values(EconFinancialHealth).map(value => ({
    value,
    hasFullWidth: true,
    label: <FinancialHealthTag color={value} />,
  }))

  return <CheckboxBasedFilter title="Financial Health" options={accountStatusOptions} {...props} />
}

export const FinancialHealthFilter = observer(_FinancialHealthFilter)
